<div class="elohn-snackbar">
@switch (data.message) {
    @case (SnackbarMessage.CLEAR_ALL_CONFIRMATION) {
    <ng-container
                  i18n="@@SnackbarMessage.CLEAR_ALL_CONFIRMATION">Alle Daten gelöscht
    </ng-container>
    }
    @case (SnackbarMessage.IMPORT_SUCCESS) {
    <ng-container
                  i18n="@@SnackbarMessage.SUCCESS">Datei {{ data.fileName }} erfolgreich importiert
    </ng-container>
    }
    @case (SnackbarMessage.IMPORT_CANCELLATION) {
    <ng-container
                  i18n="@@SnackbarMessage.CANCEL">Das Einlesen der Datei wurde abgebrochen
    </ng-container>
    }
    @case (SnackbarMessage.IMPORT_ERROR) {
    <ng-container
                  i18n="@@SnackbarMessage.ERROR">Beim Einlesen der Datei ist ein Fehler aufgetreten. {{ data.details }}
    </ng-container>
    }
    @case (SnackbarMessage.IMPORT_WRONG_EXTENSION) {
    <ng-container
                  i18n="@@SnackbarMessage.WRONG_EXTENSION">Das Einlesen der Datei {{ data.fileName }} ist nicht möglich. Nicht unterstütztes Dateiformat *.{{ data.details }}
    </ng-container>
    }
}
</div>
